import { gql } from '@apollo/client';

const CREATE_TEST_API_PROJECT = gql`
    mutation CreateTestApiProject(
        $profileId: Int!
        $projectName: String!
        $languageId1: String
        $languageId2: String
        $productIds: [Int]!
    ) {
        createTestApiProject(
            profileId: $profileId
            projectName: $projectName
            languageId1: $languageId1
            languageId2: $languageId2
            productIds: $productIds
        )
    }
`;

export default CREATE_TEST_API_PROJECT;
